import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * `page` is 0-indexed and `rows` is bounded to 200 server-side (§5.2). The caller passes exactly one
 * page: this Query never walks the whole transcript itself (D-12).
 */
class FetchTranscriptTurns {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly page: number,
		public readonly rows: number,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const queryParams = new URLSearchParams({
			page: String(this.page),
			rows: String(this.rows),
		});

		return queryParams.toString();
	}
}

export default FetchTranscriptTurns;
